import SchoolClinicListing from '.';
import { USER_ROLE } from '../../utils/constants';
import AddUpdateSchoolClinic from './addUpdateSchoolClinic';
import SchoolClinicDetails from './details';
import SCHOOL_CLINIC_LINKS from './links';

export default [
  {
    path: SCHOOL_CLINIC_LINKS.SCHOOL_CLINIC_LIST,
    exact: true,
    component: SchoolClinicListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: SCHOOL_CLINIC_LINKS.SCHOOL_CLINIC_ADD,
    exact: true,
    component: AddUpdateSchoolClinic,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: SCHOOL_CLINIC_LINKS.SCHOOL_CLINIC_EDIT,
    exact: true,
    component: AddUpdateSchoolClinic,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: SCHOOL_CLINIC_LINKS.SCHOOL_CLINIC_DETAILS,
    exact: true,
    component: SchoolClinicDetails,
    role: [USER_ROLE.ADMIN],
  },
];
